<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="bar_custname"
      placeholder="输入客户进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/money/rec_billar/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.bar_custname}}</p>
          <p class="list-item-muted">{{item.bar_code}}</p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'¥#,##0.00'">{{item.bar_amount}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.bar_status!='已审核'}"
          >{{item.bar_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}笔</label>
      <em class="list-footer__value" v-format="'¥#,##0.00'">{{getTotal('bar_amount')}}</em>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    
    return {
      listUrl: "/api/money/billar/list",
      filters: [
        {
          type: "date",
          name: "bar_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          // beforeChange,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "已收款",
              condition: "ifnull(bar_billstatus,' ')='已收款'",
            },
            {
              value: 2,
              label: "已贴现",
              condition: "ifnull(bar_billstatus,' ')='已贴现'",
            },
            {
              value: 3,
              label: "已转让",
              condition: "ifnull(bar_billstatus,' ')='已转让'",
            },
            {
              value: 4,
              label: "已退还",
              condition: "ifnull(bar_billstatus,' ')='已退还'",
            },
            {
              value: 5,
              label: "到期预警",
              condition: "bar_statuscode='AUDITED' AND bar_duedate-CURRENT_DATE<=7 and ifnull(bar_billstatus,' ')=' '",
            },
            {
              value: 6,
              label: "背书转让(供应商)",
              condition: "bar_statuscode='AUDITED' AND ifnull(bar_custid,0)<>0 and ifnull(bar_leftamount,0) > 0",
            },
          ]
        }
      ]
    };
  },
  
};
</script>